import EmbeddedFormPage from './EmbeddedFormPage';

const EarnInterestPage = () => (
  <EmbeddedFormPage
    titleKey="Earn interest"
    description="Fill out this form to start earning interest on your Wonderschool balance. Earn interest puts your idle cash to work — your balance keeps growing while you focus on running your program."
    formUrl="https://wonderschool.fillout.com/t/hPAV3vLbbPus"
  />
);

export default EarnInterestPage;
